import React, { useState, useEffect, useRef } from "react";
import Accordion from "../../components/ui/Accordion";
import AccordionItem from "../../components/ui/AccordionItem";
import "../../styles/Location.css";
import MapImage from "../../assets/india map.jpg";
import { setupMapInteractions, highlightLocation } from "./mapInteraction";

// Marker coordinates removed - using map's built-in location dots

const Locations = () => {
  const [activeLocation, setActiveLocation] = useState(null);
  const mapImageRef = useRef(null);
  const isInitialMount = useRef(true);
  const mapContainerRef = useRef(null);
  
  // Function to handle clicking on a location button
  const handleLocationClick = (locationId) => {
    setActiveLocation(locationId);
  };

  // Initialize map interactions
  useEffect(() => {
    // Setup map interactions
    setupMapInteractions();
  }, []);

  // Effect to highlight the active location marker on the map
  useEffect(() => {
    // Skip on initial mount
    if (isInitialMount.current) {
      isInitialMount.current = false;
      return;
    }
    
    if (activeLocation) {
      // Highlight the selected location on the map
      highlightLocation(activeLocation);
      
      // Find and open the correct accordion
      const button = document.querySelector(`.loc-title[data-location="${activeLocation}"]`)?.closest('.accordion-title');
      if (button) {
        button.click();
      }
    }
  }, [activeLocation]);

  return (
    <div className="location-container">
      {/* Image Slider */}
      <div className="image-slider">
        <img src="/images/slider-image.jpg" alt="Location Slider" />
      </div>

      <div className="location-content">
        {/* Left Side - Accordions */}
        <div className="location-accordion">
          {/* Bangalore - Head Office */}
          <div className="accordion-section">
            <h2 className="section-title">HEAD OFFICE</h2>
            <Accordion className="location-buttons">
              <AccordionItem 
                title={<span className="loc-title" data-location="bangalore">BANGALORE - HEAD OFFICE</span>} 
                className="location-accordion-item"
              >
                <div className="accordion-card">
                  <p><strong>Puyvast Logistics Pvt. Ltd</strong></p>
                  <p>"PuyVast House"</p>
                  <p>4th Floor ,# 6, Harris Road, Benson Town,</p>
                  <p>Bangalore - 560 046.</p>
                  <p><strong>Landline :</strong> +91 80 23549190</p>
                 
                  <p><strong>Email :</strong> <a href="mailto:commercial@puyvast.co.in">commercial@puyvast.co.in</a></p>
                </div>
              </AccordionItem>
            </Accordion>
          </div>

          {/* Branch Offices */}
          <div className="accordion-section">
            <h2 className="section-title">BRANCH OFFICES</h2>
            <Accordion className="location-buttons">
              <AccordionItem 
                title={<span className="loc-title" data-location="chennai">CHENNAI / KATTUPALLI / ENNORE</span>}
                className="location-accordion-item"
              >
                <div className="accordion-card">
                  <p><strong>Puyvast Logistics Pvt. Ltd</strong></p>
                  <p>Brooklyn Business Center</p>
                  <p>West Wing , 4 th Floor,103-105, Poonamllee High Road</p>
                  <p>Ennore, Chennai - 600 004.</p>
                  <p><strong>Mobile:</strong> +91 44 42177103 /28116652</p>
                  <p><strong>Fax:</strong> +91 44 42177106</p>
                  <p><strong>Email:</strong> <a href="mailto:plplchn@puyvast.co.in">plplchn@puyvast.co.in</a></p>
                </div>
              </AccordionItem>
              <AccordionItem 
                title={<span className="loc-title" data-location="vizag">VIZAG / GANGAVARAM / GOPALPUR</span>}
                className="location-accordion-item"
              >
                <div className="accordion-card">
                  <p><strong>Puyvast Logistics Pvt Ltd</strong></p>
                  <p>203 B, 2nd Floor,</p>
                  <p>Dutt Island Complex, Siripuram,</p>
                  <p>Visakhapatnam - 530 003.</p>
                  <p><strong>Mobile:</strong> 0891-2514832 / 6636768</p>
                  <p><strong>Fax:</strong> 0891-2514843</p>
                  <p><strong>Email:</strong> <a href="mailto:puyvastvzg@puyvast.co.in">puyvastvzg@puyvast.co.in</a></p>
                </div>
              </AccordionItem>
              <AccordionItem 
                title={<span className="loc-title" data-location="kakinada">KAKINADA</span>}
                className="location-accordion-item"
              >
                <div className="accordion-card">
                  <p><strong>Puyvast Logistics Pvt Ltd</strong></p>
                  <p>Door No. 16-23-17 / 2B/1, Road No. 3,</p>
                  <p>Ayodhya Nagar,</p>
                  <p>Kakinada - 533 003.</p>
                  <p><strong>Mobile:</strong> 0884-6450166</p>
                  <p><strong>Fax:</strong> 0884-2353648</p>
                  <p><strong>Email:</strong> <a href="mailto:puyvastkkd@puyvast.co.in">puyvastkkd@puyvast.co.in</a></p>
                </div>
              </AccordionItem>
              <AccordionItem 
                title={<span className="loc-title" data-location="krishnapatnam">KRISHNAPATNAM</span>}
                className="location-accordion-item"
              >
                <div className="accordion-card">
                  <p><strong>Puyvast Logistics Pvt Ltd</strong></p>
                  <p>H.No.26-14-941, 197, </p>
                  <p>1st Floor, Street No.550, Beside Thati  Bellam Street, Mini By-Pass Road, </p>
                  <p>B. V. Nagar, Nellore - 524004.</p>
                  <p><strong>Mobile:</strong> 0861-2333007</p>
                  <p><strong>Fax:</strong> 0861-2333007</p>
                  <p><strong>Email:</strong> <a href="mailto:puyvastkpatnam@puyvast.co.in">puyvastkpatnam@puyvast.co.in</a></p>
                </div>
              </AccordionItem>
             
              <AccordionItem 
                title={<span className="loc-title" data-location="karwar">KARWAR</span>}
                className="location-accordion-item"
              >
                <div className="accordion-card">
                  <p><strong>Puyvast Logistics Pvt Ltd</strong></p>
                  <p>Opp. Port Office, Baithkol,</p>
                  <p>Karwar - 581 302</p>
                  <p><strong>Mobile:</strong> +91 8382 229998</p>
                  <p><strong>Fax:</strong> +91 8382 229997</p>
                  <p><strong>Email:</strong> <a href="mailto:puyvastkwr@puyvast.co.in">puyvastkwr@puyvast.co.in</a></p>
                </div>
              </AccordionItem>
            </Accordion>
          </div>

          {/* Associates */}
          <div className="accordion-section">
            <h2 className="section-title">ASSOCIATES</h2>
            <Accordion className="location-buttons">
              <AccordionItem 
                title={<span className="loc-title" data-location="kandla">KANDLA / MUNDRA</span>}
                className="location-accordion-item"
              >
                <div className="accordion-card">
                  <p><strong>Krishna Shipping and Allied Services</strong></p>
                  <p>53/54 A, Transport Nagar,</p>
                  <p>Gandhidam, Gujarat,</p>
                  <p>India - 370201</p>
                  <p><strong>Mobile:</strong> +91 2836 223814 / 230501</p>
                  <p><strong>Fax:</strong> +91 2836 233135</p>
                  <p><strong>Email:</strong> <a href="mailto:ksas@krishnashippingkdl.com">ksas@krishnashippingkdl.com</a></p>
                </div>
              </AccordionItem>
              <AccordionItem 
                title={<span className="loc-title" data-location="mumbai">MUMBAI</span>}
                className="location-accordion-item"
              >
                <div className="accordion-card">
                  <p><strong>M/s. Seaworld Shipping & Logistics Pvt. Ltd.</strong></p>
                  <p>'NCL', 8th Floor, Bandra-Kurla Complex,</p>
                  <p>Bandra (East), Mumbai - 400 051</p>
                  <p><strong>Mobile:</strong> +91 22 6698 8860 / 92 (DD), +91 22 6698 8888 (Board)</p>
                  <p><strong>Fax:</strong> +91 22 6698 8822</p>
                  <p><strong>Email:</strong> <a href="mailto:seaworldops@seaworldship.com">seaworldops@seaworldship.com</a></p>
                </div>
              </AccordionItem>
              <AccordionItem 
                title={<span className="loc-title" data-location="goa">GOA</span>}
                className="location-accordion-item"
              >
                <div className="accordion-card">
                  <p><strong>Marinelinks Shipping Agencies</strong></p>
                  <p>#207, 2nd Floor, Rohan Arcade,</p>
                  <p>Opp. MPT Institute, Swantantra Path,</p>
                  <p>Vasco Da Gama, Goa - 403 802.</p>
                  <p><strong>Mobile:</strong> +91 832 2510255</p>
                  <p><strong>Fax:</strong> +91 832 2510266</p>
                  <p><strong>Email:</strong> <a href="mailto:goa@marinelinks.in">goa@marinelinks.in</a></p>
                </div>
              </AccordionItem>
              <AccordionItem 
                title={<span className="loc-title" data-location="mangalore">MANGALORE</span>}
                className="location-accordion-item"
              >
                <div className="accordion-card">
                  <p><strong>Marinelinks Shipping Agencies</strong></p>
                  <p>1st Floor Abco Trade Centre,</p>
                  <p>Kottara Chowki, Mangalore - 575 006.</p>
                  <p><strong>Mobile:</strong> +91 824 4280008 / 4280009</p>
                  <p><strong>Fax:</strong> +91 824 4280002 / 2458301</p>
                  <p><strong>Email:</strong> <a href="mailto:mangalore@marinelinks.in">mangalore@marinelinks.in</a></p>
                </div>
              </AccordionItem>
              <AccordionItem 
                title={<span className="loc-title" data-location="tuticorin">TUTICORIN</span>}
                className="location-accordion-item"
              >
                <div className="accordion-card">
                  <p><strong>Diamond Shipping Agencies</strong></p>
                  <p>"Diamond House",</p>
                  <p>Type - A, Plot No. 4, World Trade Avenue</p>
                  <p>Harbour Estate, Tuticorin - 628 004.</p>
                  <p><strong>Mobile:</strong> +91 461 4033333</p>
                  <p><strong>Fax:</strong> +91 461 4033311</p>
                  <p><strong>Email:</strong> <a href="mailto:info@diamondshipping.in">info@diamondshipping.in</a></p>
                </div>
              </AccordionItem>
              <AccordionItem 
                title={<span className="loc-title" data-location="paradip">PARADIP</span>}
                className="location-accordion-item"
              >
                <div className="accordion-card">
                  <p><strong>G. Pattabhi Ramayya & Co.</strong></p>
                  <p>'Ram Nivas',</p>
                  <p>Plot No.47, Behind Bank Street,</p>
                  <p>Paradip Port, Odisha - 754 142</p>
                  <p><strong>Mobile:</strong> +91 6722 222218</p>
                  <p><strong>Fax:</strong> +91 6722 222372</p>
                  <p><strong>Email:</strong> <a href="mailto:paradip@gprnco.com">paradip@gprnco.com</a></p>
                </div>
              </AccordionItem>
              <AccordionItem 
                title={<span className="loc-title" data-location="kolkata">KOLKATA / HALDIA</span>}
                className="location-accordion-item"
              >
                <div className="accordion-card">
                 <p><strong>B Ghose & Co Pvt Ltd.</strong></p>
                 
                  <p>19/1 Camac Street </p>
                  <p>Kolkata - 700017</p>
                  <p><strong>Tel:</strong> +91 3322 872090</p>
                  <p><strong>Fax:</strong> +91 33 2287 3380</p>
                  <p><strong>Email:</strong> <a href="mailto:operations@bghose.com">operations@bghose.com</a></p>
                  {/* <p>Please add the address details here</p> */}
                </div>
              </AccordionItem>
            </Accordion>
          </div>
        </div>

        {/* Right Side - Map Image */}
        <div className="location-map">
          <div className="map-container" ref={mapContainerRef}>
            <img 
              src={MapImage} 
              alt="Map" 
              className="map-image" 
              ref={mapImageRef}
            />

            
            {/* Markers removed - using map's built-in location dots instead */}
{/* HEAD OFFICE */}
<div className="map-marker head-office-marker bangalore" title="Bangalore"
     style={{ bottom: "20%", left: "32%" }} />
     {/* KARNATAKA */}
<div className="map-marker branch-office-marker mangalore" title="Mangalore"
     style={{ bottom: "16.5%", left: "28%" }} />

<div className="map-marker branch-office-marker karwar" title="Karwar"
     style={{ bottom: "18.5%", left: "26%" }} />

{/* TAMIL NADU */}
<div className="map-marker branch-office-marker chennai" title="Chennai"
     style={{ bottom: "19%", left: "42%" }} />

<div className="map-marker branch-office-marker kattupalli" title="Kattupalli"
     style={{ bottom: "16%", left: "39.9%" }} />

<div className="map-marker branch-office-marker ennore" title="Ennore"
     style={{ bottom: "17.5%", left: "41%" }} />

<div className="map-marker branch-office-marker tuticorin" title="Tuticorin"
     style={{ bottom: "9%", left: "35%" }} />

{/* ANDHRA PRADESH */}
<div className="map-marker branch-office-marker vizag" title="Vizag"
     style={{ bottom: "34%", left: "48.5%" }} />

<div className="map-marker branch-office-marker gangavaram" title="Gangavaram"
     style={{ bottom: "32%", left: "46.72%" }} />

<div className="map-marker branch-office-marker kakinada" title="Kakinada"
     style={{ bottom: "29%", left: "46.5%" }} />

<div className="map-marker branch-office-marker krishnapatnam" title="Krishnapatnam"
     style={{ bottom: "25%", left: "42%" }} />

<div className="map-marker branch-office-marker gopalpur" title="Gopalpur"
     style={{ bottom: "40%", left: "54%" }} />

<div className="map-marker branch-office-marker paradip" title="Paradip"
     style={{ bottom: "43%", left: "60%" }} />



{/* GOA */}
<div className="map-marker associate-marker goa" title="Goa"
     style={{ bottom: "26%", left: "24%" }} />

{/* MAHARASHTRA */}
<div className="map-marker associate-marker mumbai" title="Mumbai"
     style={{ bottom: "36%", left: "22%" }} />

{/* GUJARAT */}
<div className="map-marker associate-marker kandla" title="Kandla"
     style={{ bottom: "50%", left: "16%" }} />

<div className="map-marker associate-marker mundra" title="Mundra"
     style={{ bottom: "52%", left: "13.5%" }} />

{/* WEST BENGAL */}
<div className="map-marker associate-marker kolkata" title="Kolkata"
     style={{ bottom: "50%", left: "65%" }} />

<div className="map-marker associate-marker haldia" title="Haldia"
     style={{ bottom: "47%", left: "62.5%" }} />
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="footer">
        <div className="footer-container">
          {/* Left Section - CIN & Links */}
          <div className="footer-left">
            <p>CIN Number: U63030KA2022PTC161825</p>
            <p>
              <a href="/privacy-statement" className="footer-link">Privacy Statement</a> | 
              <a href="/terms-of-use" className="footer-link"> Terms Of Use</a>
            </p>
          </div>

          {/* Center - Copyright */}
          <div className="footer-center">
            <p>© {new Date().getFullYear()} ONEVEGA Systems (India) Pvt Ltd.</p>
          </div>

          {/* Right Section - Registered Office */}
          <div className="footer-right">
            <p><strong>Registered Office</strong></p>
            <p>Puyvast Logistics Pvt. Ltd.</p>
            <p>PuyVast House </p>
            <p>4th Floor ,#6, Harris Road, Benson Town,<br></br> Bangalore - 560 046.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Locations;